var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9161 5.24435C22.6946 6.02285 22.6946 7.28515 21.9161 8.06365L20.3861 9.59365L14.9063 4.11395L16.4364 2.58395C17.215 1.80535 18.4772 1.80535 19.2557 2.58395L21.9161 5.24435ZM3.65202 21.9896L8.04732 21.3617C8.47962 21.2999 8.88012 21.0997 9.18882 20.7909L18.9593 11.0205L13.4796 5.54085L3.70912 15.3112C3.40032 15.6199 3.20012 16.0205 3.13832 16.4527L2.51042 20.848C2.41522 21.5139 2.98612 22.0848 3.65202 21.9896Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.3073eebbcf8c006ddc721f0a5e25edc1.svg";
export { ForwardRef as ReactComponent };